import React from 'react';

const SummaryCategoryHeader = () => {
	//lg:text-lg md:text-xs text-xxs
	return <div className={`grid grid-cols-5 bg-opacity-0 rounded-full w-full font-gSemi md:text-xs text-xxs px-3 pt-2 text-primary uppercase`}>
		<div className={'text-left self-end text-xs col-span-2'}>Category</div>
		<div className={'text-right self-end text-xs col-start-4'}>Wedges Collected</div>
		<div className={'text-right self-end text-xs col-start-5'}>Trivia Score</div>
	</div>
}

export default SummaryCategoryHeader;
